import * as React from 'react';

import {getCommaSeparatedList} from 'nutshell-core/get-comma-separated-list';

// @ts-expect-error - imported from .js/.jsx file

import {InboundCallIcon} from 'shells/icon/svg/inbound-call-icon';
// @ts-expect-error - imported from .js/.jsx file
import {MapPinIcon} from 'shells/icon/svg/map-pin-icon';
// @ts-expect-error - imported from .js/.jsx file
import {OutboundCallIcon} from 'shells/icon/svg/outbound-call-icon';
// @ts-expect-error - imported from .js/.jsx file
import {SolidClockIcon} from 'shells/icon/svg/solid-clock-icon';
// @ts-expect-error - imported from .js/.jsx file
import {VirtualMeetingIcon} from 'shells/icon/svg/virtual-meeting-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Header} from 'shells/typography/header';

import type {MeetingLocationType} from 'nutshell-graphql-types';

import {getDurationMinutesText} from '../../../core/get-duration-minutes-text';

type Props = {
    name: string;
    description: string | null | undefined;
    durationMinutes: number;
    locationType: MeetingLocationType | null | undefined;
    location: string | null | undefined;
    hostUser: {
        name: string;
        firstName: string | null | undefined;
    };
    cohostNames: string[];
};

export function FormHeader(props: Props) {
    const meetingDurationText = getDurationMinutesText(props.durationMinutes);

    const getLocationIcon = () => {
        let LocationIcon = MapPinIcon;

        switch (props.locationType) {
            case 'INBOUND_CALL':
                LocationIcon = InboundCallIcon;
                break;
            case 'OUTBOUND_CALL':
                LocationIcon = OutboundCallIcon;
                break;
            case 'MEET':
            case 'TEAMS':
            case 'ZOOM':
                LocationIcon = VirtualMeetingIcon;
                break;
        }

        return <LocationIcon size={13} alignCenter={true} />;
    };

    const getLocationText = (): string | null | undefined => {
        if (props.locationType === 'ADDRESS' && props.location) {
            return props.location;
        } else if (props.locationType === 'INBOUND_CALL' && props.location) {
            return `Call ${
                props.cohostNames.length ? 'hosts' : props.hostUser.firstName || props.hostUser.name
            } at ${props.location}`;
        } else if (props.locationType === 'OUTBOUND_CALL') {
            return `${
                props.cohostNames.length ? 'Hosts' : props.hostUser.firstName || props.hostUser.name
            } will call you at the number you provide`;
        } else if (props.locationType === 'ZOOM') {
            return 'Zoom link provided in confirmation email';
        } else if (props.locationType === 'MEET') {
            return 'Google Meet link provided in confirmation email';
        } else if (props.locationType === 'TEAMS') {
            return 'Microsoft Teams link provided in confirmation email';
        } else {
            return 'No location';
        }
    };

    return (
        <StackLegacy spacing={12}>
            <StackLegacy spacing={4}>
                <div className='light-text'>Meet with:</div>
                <div className='font-bold'>
                    {getCommaSeparatedList([props.hostUser.name, ...props.cohostNames])}
                </div>
            </StackLegacy>
            <StackLegacy spacing={4}>
                <Header>{props.name}</Header>
                {props.description}
            </StackLegacy>
            <StackLegacy spacing={4}>
                <StackLegacy isHorizontal={true} spacing={8} alignCenter={true}>
                    <SolidClockIcon size={13} alignCenter={true} />
                    {meetingDurationText}
                </StackLegacy>
                <StackLegacy isHorizontal={true} spacing={8} alignCenter={true}>
                    {getLocationIcon()}
                    {getLocationText()}
                </StackLegacy>
            </StackLegacy>
        </StackLegacy>
    );
}
